import React from 'react';
import BackgroundImage from '../components/BackgroundImage/BackgroundImage';
import logoWhite from '../assets/sample-logo.png';
import logo from '../assets/logo.svg';
import CreateAccountForm from '../components/CreateAccountForm/CreateAccountForm';

const SplitSolidColorBackground = () => (
  <div className="container-fluid">
    <div className="row min-vh-100">
      <BackgroundImage
        backgroundColor="#007aff"
        heading="Welcome!"
        subheading="Join the best collection of premium React starter kits around. Just enter your email and password to continue."
        logo={logoWhite}
      />
      <CreateAccountForm
        heading="Create Account"
        subheading="Enter your first name, last name, and email address below"
        image={logo}
        backgroundColor="#f8f9fa"
      />
    </div>
  </div>
);

export default SplitSolidColorBackground;
